import { createFileRoute } from '@tanstack/react-router';

import discordLfgAppPrivacyHtml from '#features/static-pages/assets/discord-lfg-app-privacy-policy.html?raw';
import { EmbeddedHtmlPage } from '#features/static-pages/components/EmbeddedHtmlPage';
import { legalPageOverrides } from '#features/static-pages/constants/legalPageOverrides';
import { staticPageHead } from '#features/static-pages/utils/head';
import { withLegalEnhancements } from '#features/static-pages/utils/legalEnhancements';

const title = 'Privacy Policy for Teamplay LFG App for Discord';
const description =
  'Privacy policy for the Teamplay LFG App for Discord, including data collection, usage, and user rights.';

export const Route = createFileRoute('/{-$locale}/_layout/discord-lfg-app/privacy-policy')({
  component: DiscordLfgAppPrivacyPolicyPage,
  head: () =>
    staticPageHead({
      title,
      description,
      pathname: '/discord-lfg-app/privacy-policy',
    }),
});

function DiscordLfgAppPrivacyPolicyPage() {
  const { locale } = Route.useParams();
  const localePrefix = locale === 'ru' ? '/ru' : '';
  const enhancedHtml = withLegalEnhancements(discordLfgAppPrivacyHtml, {
    fallbackUpdatedAt: 'Published on Teamplay.gg',
    quickLinks: [
      { href: `${localePrefix}/discord-lfg-app/privacy-policy`, label: 'App Privacy' },
      { href: `${localePrefix}/discord-lfg-app/terms-and-conditions`, label: 'App Terms' },
      { href: `${localePrefix}/privacy-policy`, label: 'Main Privacy' },
    ],
  });

  return (
    <EmbeddedHtmlPage
      html={enhancedHtml}
      title="Discord LFG App Privacy Policy"
      minHeight={950}
      extraStyles={legalPageOverrides}
      runInlineScripts
      shellWidth="980px"
      showReadingProgress
      showBackToTop
      enableSectionAnchors
    />
  );
}
